module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid-Mobility-Kits4-scaled.df60ab1b.jpg";